import React, { Component } from 'react';
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";
import {
  changeTopbarTheme,
} from "../store/actions";

class NonAuthLayout extends Component {
    constructor(props) {
        super(props);
        this.state={};
        this.capitalizeFirstLetter.bind(this);
    }

    capitalizeFirstLetter = string => {
        return string.charAt(1).toUpperCase() + string.slice(2);
      };

    componentDidMount(){
        let currentage = this.capitalizeFirstLetter(this.props.location.pathname);

        if (this.props.changeTopbarTheme) {
          this.props.changeTopbarTheme(this.props.topbarTheme);
        }

        document.title =
          currentage.replace("/"," - ") + " | Het Laser Lokaal";
    }
    render() {
        return <React.Fragment>
            {this.props.children}
        </React.Fragment>;
    }
}

const mapStatetoProps = state => {
  return {
    ...state.Layout
  };
};

export default connect(mapStatetoProps, {
  changeTopbarTheme
})(withRouter(NonAuthLayout));
